module.exports = __webpack_public_path__ + "static/services-cs-cb-f2ee7bb2c86b13b63d1dd43379183ca9.png";